import '../ranking_view.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.FacebookUserRankingChartView extends Monitoring.Views.Charts.RankingChartView
  ranking_template: JST["backbone/templates/monitoring/charts/facebook_user_ranking"]
  className: 'chart-ranking facebook-ranking item w2 h3'

  initialize: (@options = {}) ->
    @filename = 'facebook_ranking.png'
    @pendingRequests = []
    super

  render: ->
    rank_title = "Rankings de Facebook"
    @$el.html(@generic_template({rankings:_.map(@selectedRankings(), (ranking) -> ranking.settings()), results: @defaultResults, rank_title}))
    for rank in @selectedRankings()
      @listenTo(rank, 'ranking:load:finished', @processRanking)
      rank.loadData(@searchQuery, @defaultResults, @displayError)
      @pendingRequests.push rank
    @trigger('masonry')

  processRanking: (ranking) =>
    return if @pendingRequests.length == 0
    @pendingRequests.remove(ranking)
    try
      @handleResponse(ranking.result(), ranking.settings())
    catch error
      @handleResponseErrors error

  abortPendingRequests: ->
    request.abortRequest() for request in @pendingRequests

  maxResults: ->
    50

  selectedRankings: ->
    [
      new Charts.UserRanking({id:'user_ranking', title:I18n.t('monitoring.dashboard.charts.user_ranking'), spanSize: 4}),
      new Charts.UserRanking({id:'approved_user_ranking_chart', title:I18n.t('monitoring.dashboard.charts.ranking.most_approved'), status:'approved', spanSize: 4}),
      new Charts.UserRanking({id:'rejected_user_ranking_chart', title:I18n.t('monitoring.dashboard.charts.ranking.most_rejected'), status:'rejected', spanSize: 4})
    ]
